import { db } from '../config';
import { collection, addDoc, query, where, getDocs, Timestamp } from 'firebase/firestore';

export interface Customer {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  status: 'active' | 'inactive';
  dateCreated: Date;
  notes?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
}

export const createCustomer = async (customerData: Omit<Customer, 'id'>): Promise<Customer> => {
  try {
    const customersRef = collection(db, 'customers');
    const docRef = await addDoc(customersRef, {
      ...customerData,
      dateCreated: Timestamp.fromDate(customerData.dateCreated)
    });
    
    return {
      ...customerData,
      id: docRef.id
    };
  } catch (error) {
    console.error('Error creating customer:', error);
    throw new Error('Failed to create customer');
  }
};

export const getCustomerByEmail = async (email: string): Promise<Customer | null> => {
  try {
    const customersRef = collection(db, 'customers');
    const q = query(customersRef, where('email', '==', email.toLowerCase()));
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      return null;
    }
    
    const doc = querySnapshot.docs[0];
    const data = doc.data();
    
    return {
      id: doc.id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      status: data.status,
      dateCreated: data.dateCreated.toDate(),
      notes: data.notes,
      address: data.address
    };
  } catch (error) {
    console.error('Error finding customer:', error);
    throw new Error('Failed to find customer');
  }
}; 